module.exports = __webpack_public_path__ + "static/organicgeometric1-0d76ffa359836351d12b7a7fb2cd28b2.png";